<template>
  <div class="menu">
    <div class="menu__wrap">
      <transition appear mode="out-in" @appear="enterText" @enter="enterText" @leave="leaveText">
        <div v-show="showChild">
          <div v-bind:class="this.hamburgerColor" class="navigation-toggle">
            <div
              class="navigation-toggle-bar"
              v-on:click="showMenu = !showMenu, showSubMenu = false, submenuType = '', hamburgerColorToggle()"
            ></div>
          </div>
        </div>
      </transition>
    </div>

    <div class="navigation">
      <FloatingContact :style="{margin: '0 50px 20px 0'}" />
      <transition name="menu-fade-left" mode="out-in">
        <div class="navigation__box" v-if="showMenu">
          <ul>
            <li>
              <span>Check out the showreel</span>
              <a v-on:click="showSubMenu=false; goToSection(0)" href="#">Start</a>
            </li>
            <li>
              <span>Check out our portfolio</span>
              <a v-on:click="showSubMenu=true, submenuType='case_study'" href="#">Case Study</a>
            </li>
            <li>
              <span>Find out more about us</span>
              <a v-on:click="showSubMenu=true, submenuType='about'" href="#">About</a>
            </li>
            <li>
              <span>Contact us</span>
              <a v-on:click="showSubMenu=false, goToSection(12)">Contact</a>
            </li>
          </ul>
        </div>
      </transition>
      <div class="navigation__box">
        <transition name="submenu-fade-left">
          <div v-show="showSubMenu" class="navigation__container">
            <div
              class="navigation__box--sub-button"
              v-on:click="showSubMenu = false, submenuType = ''"
            >
              <div class="navigation__box--sub-button--insider"></div>
            </div>
            <SubMenu :submenuType="this.submenuType" @changeActiveSection="goToSection($event)"></SubMenu>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenu from "@/components/small-components/SubMenu";
import FloatingContact from "@/components/small-components/FloatingContact";


export default {
  name: "Menu",
  data() {
    return {
      showSubMenu: false,
      showMenu: false,
      submenuType: "",
      floatingContactColor: "#cacaca",
      floatingContactLetterColor: "#000",
      menuOpen: false
    };
  },
  props: [
    "hamburgerColor",
    "title",
    "dot",
    "textColor",
    "specificationColor",
    "agency",
    "client",
    "role",
    "url",
    "showChild",
    "sectionType",
    "subtitle",
    "horizontalPosition",
    "disableScroll",
    "offClickMenu"
  ],
  mounted: function() {
    this.hamburger();
  },
  watch: {
    showMenu: function() {
      if (this.showMenu == false) {
        this.$emit("disableScrollMenu", false);
        this.$emit("isBlackChange", false);
      } else {
        this.$emit("disableScrollMenu", true);
        this.$emit("isBlackChange", true);
      }
    }
  },

  methods: {
    hamburgerColorToggle: function() {
      this.menuOpen == true;
    },
    // Menu hamburger animation
    enterText: function(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        { x: "-105%" },
        {
          x: "0%",
          // delay: 0.5,
          // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
          onComplete: done
        }
      );
    },
    leaveText: function(el, done) {
      TweenMax.to(el, 0.5, {
        x: "105%",
        // delay: .2,
        // ease: CustomEase.create("custom", ".86,.21,.87,.99"),
        onComplete: done
      });
    },

    hamburger() {
      (function() {
        var hamburger = {
          navigationToggle: document.querySelector(".navigation-toggle"),
          navigation: document.querySelector(".navigation"),

          doToggle: function(e) {
            e.preventDefault();
            this.navigationToggle.classList.toggle("expanded");
            this.navigation.classList.toggle("expanded");
          }
        };

        hamburger.navigationToggle.addEventListener("click", function(e) {
          hamburger.doToggle(e);
        });
      })();
    },
    goToSection: function(sectionNumber) {
      this.$emit("changeActiveSection", sectionNumber);
      this.$router.push({
        name: "HomePage",
        params: { activeSection: sectionNumber }
      });

      this.showMenu = false;
      document.querySelector(".navigation-toggle").classList.toggle("expanded");
      document.querySelector(".navigation").classList.toggle("expanded");
    },
    disableScrolling: function() {
      if (this.showMenu == false) {
        this.$emit("disableScrollMenu", false);
      } else {
        this.$emit("disableScrollMenu", true);
      }
    }
  },

  components: {
    SubMenu,
    FloatingContact,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/Menu.vue